import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import modalComponent from "@/components/child/modal/modal.vue";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import { Component, Prop, Watch } from "@/decorators";
import ConfiguracaoFranquiaModel from "@/models/configuracaoFranquia/configuracaoFranquiaModel";
import Configuracoes from "@/models/enum/configuracao/configuracoes";
import SituacoesVendaItem from "@/models/enum/situacoesVendaItem";
import TipoNotaFiscal from "@/models/enum/tipoNotaFiscal";
import TiposProduto from "@/models/enum/tiposProduto";
import PacienteModel from "@/models/paciente/pacienteModel";
import PaginationModel from "@/models/paginationModel";
import PosologiaModel from "@/models/posologiaModel";
import PrescritorModel from "@/models/prescritorModel";
import ProdutoModel from "@/models/produto/produtoModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import UsuarioModel from "@/models/usuarioModel";
import VendaItemModel from "@/models/vendaItemModel";
import estoqueByFranquiaService from "@/services/estoqueByFranquiaService";
import EstoqueComprometidoService from "@/services/estoqueComprometidoService";
import estoqueService from "@/services/estoqueService";
import posologiaService from "@/services/posologiaService";
import PrescritorService from "@/services/prescritorService";
import produtoService from "@/services/produto/produtoService";
import ProdutoLoteService from "@/services/produtoLoteService";
import unidadeMedidaService from "@/services/unidadeMedidaService";
import VendaContinuoService from "@/services/vendaContinuoService";
import { AppState, Getters, SessionActions } from "@/store/store";
import arithmeticHelper from "@/utils/common/arithmeticHelper";
import {
    getPacienteCombo,
    getPosologiaCombo,
    getPrescritorCombo,
    getProdutoCombo,
    getProdutoLoteCombo,
} from "@/utils/common/combo/combotext";
import Delay from "@/utils/common/delay";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import PacienteComponent from "../crud/paciente/edit";
import pacienteComponent from "../crud/paciente/edit.vue";
import PosologiaComponent from "../crud/posologia/edit";
import posologiaComponent from "../crud/posologia/edit.vue";
import PrescritorComponent from "../crud/prescritor/edit";
import prescritorComponent from "../crud/prescritor/edit.vue";

@Component({
    components: {
        comboComponent,
        searchComboComponent,
        moedaComponent,
        modalComponent,
        pacienteComponent,
        prescritorComponent,
        decimalComSinalCustomComponent,
        posologiaComponent,
        fieldsetComponent,
        dateTimePickerComponent,
        checkboxComponent,
    },
    computed: {
        ...mapState<AppState>({
            usuarioLogado: state => state.session.usuarioLogado,
        }),
        ...mapGetters(["GET_CONFIG_FRANQUIA", "GET_IS_FRACIONAMENTO", "GET_IS_ESTEREIS"] as Getters),
        quantidadeEstoqueLoteString() {
            return `${this.produtoLoteModel.quantidadeAtual.toString().replace(".", ",")} ${this.unidadeMedidaSigla}`;
        },
        quantidadeComprometidaLoteString() {
            return `${this.quantidadeComprometidaLote.toString().replace(".", ",")} ${this.unidadeMedidaSigla}`;
        },
        quantidadeDisponivelString() {
            return `${(this.produtoLoteModel.quantidadeAtual - this.quantidadeComprometidaLote)
                .toString()
                .replace(".", ",")} ${this.unidadeMedidaSigla}`;
        },
        isPosologiaTextoLivre() {
            return this.GET_CONFIG_FRANQUIA(Configuracoes.PosologiasTextoLivre).verdadeiro;
        },
    },
})
export default class AcabadoForm extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;
    isPosologiaTextoLivre: boolean;
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;
    GET_CONFIG_FRANQUIA: (configuracao: Configuracoes) => ConfiguracaoFranquiaModel;

    private produtoLoteService = new ProdutoLoteService();
    private estoqueComprometidoService = new EstoqueComprometidoService();
    private vendaContinuoService = new VendaContinuoService();
    private pacienteComponent: PacienteComponent = null;
    private posologiaComponent: PosologiaComponent = null;
    private prescritorComponent: PrescritorComponent = null;

    private editingModel = false;
    private uplodingModel = false;

    private showWarningEstoque = false;
    private showPrescritor = false;
    private showPaciente = false;
    private continuo = false;
    private dataVencimentoContinuo: Date = null;

    isFracionamento = false;
    private isEstereis = false;
    isObrigatorioProdutoLote = false;
    quantidadeComprometidaLote = 0;
    unidadeMedidaSigla = "";

    model: VendaItemModel = new VendaItemModel();
    markup = 0;
    private prescritorModel = new PrescritorModel();
    private produtoLoteModel = new ProdutoLoteModel();

    suggestions = [
        { descricao: "desc 1", subDescricao: "subdescricao" },
        { descricao: "desc 2", subDescricao: "subdescricao" },
        { descricao: "desc 3", subDescricao: "subdescricao" },
        { descricao: "desc 4", subDescricao: "subdescricao" },
    ];
    selection = "";

    situacoesVendaItemOptions: Array<Object> = [
        { text: "Aprovado", value: SituacoesVendaItem.Aprovado },
        { text: "Cancelado", value: SituacoesVendaItem.Cancelado },
        { text: "Conclu\u00eddo", value: SituacoesVendaItem.Concluido },
        { text: "Or\u00e7amento", value: SituacoesVendaItem.Orcamento },
        { text: "Rejeitado", value: SituacoesVendaItem.Rejeitado },
    ];

    private tipoNFOptions: Array<object> = [
        { text: "NFC-e", value: TipoNotaFiscal.CupomFiscal },
        { text: "NF-e", value: TipoNotaFiscal.DANFe },
    ];

    produtosOptions: Array<Object> = [];
    produtosLoteOptions: Array<Object> = [];
    unidadeMedidaOptions: Array<Object> = [];
    estoquesOptions: Array<object> = [];

    pacienteDescricao: string = null;

    private produtoLoteIdSelecionado?: number | null = null;

    private customComboTextPaciente = getPacienteCombo;
    private customComboTextPrescritor = getPrescritorCombo;
    private customComboTextPosologia = getPosologiaCombo;

    @Prop(Number) pacienteIdApp: number;
    @Prop(Number) clienteId: number;
    @Prop({ type: Boolean, default: false }) vendaFaturada: boolean;
    @Prop({ type: Boolean, default: false }) utilizaValorCusto: boolean;
    @Prop({ type: Boolean, default: false }) isSituacaoPreVenda: boolean;

    public clear(newItem = false) {
        this.model = new VendaItemModel();
        this.model.tipoNF = this.isEstereis ? TipoNotaFiscal.DANFe : TipoNotaFiscal.CupomFiscal;

        if (newItem) {
            this.loadEstoques();
        }

        this.$focusField("produtoId");
        this.pacienteDescricao = null;
        this.editingModel = false;
        this.showWarningEstoque = false;
        this.$forceUpdate();
    }

    private async loadProdutos(refresh = false) {
        const data = await produtoService.comboCached(this.usuarioLogado.franquiaId!, refresh);

        this.produtosOptions = data.filter(p => p.tipoProdutoId == TiposProduto.Acabado);
    }

    public async onAdicionarItem() {
        const isValid = await this.$validator.validateAll();
        if (!isValid) {
            this.$focusErrorField();
            return false;
        }

        if (this.model.produtoLoteId) {
            if (
                this.produtoLoteModel.quantidadeAtual - this.quantidadeComprometidaLote <
                    Number(this.model.quantidade) &&
                !(await this.$showQuestion(this.$t("__.ts.semEstoqueTitulo"), this.$t("__.ts.semEstoqueMsg")))
            ) {
                return false;
            }

            this.emitirEventoAdicionar();
            return true;
        } else {
            if (this.model.movimentaEstoque) {
                await this.$showWarning(
                    this.$t("__.ts.flagMovEstqMarcadaTitulo"),
                    this.$t("__.ts.flagMovEstqMarcadaMsg"),
                );
                return false;
            } else {
                this.emitirEventoAdicionar();
                return true;
            }
        }
    }

    private async emitirEventoAdicionar() {
        if (this.editingModel) {
            this.$emit("edicao-item", this.getModel());
        } else {
            this.$emit("inclusao-item", this.getModel());
        }

        this.clear();
    }

    @Watch("continuo")
    @Watch("dataVencimentoContinuo")
    private onChangeContinuo() {
        this.model.continuo = this.continuo;
        this.model.dataVencimentoContinuo = this.dataVencimentoContinuo;
    }

    private getModel() {
        const model = new VendaItemModel();
        model.updateFrom(this.model);
        model.produtoDescricao = this.produtosOptions.find(it => it["value"] == model.produtoId)["text"];
        model.produtoDescricao = model.produtoDescricao.replace("((", "(");
        model.produtoDescricao = model.produtoDescricao.replace("))", ")");

        return model;
    }

    @Watch("model.estoqueId")
    private async onEstoqueIdChanged() {
        if (this.usarEstoqueEntreFiliais() && this.model.estoqueId) {
            const estoqueFiliais = this.usarEstoqueEntreFiliais()
                ? await estoqueByFranquiaService.comboCachedByFranquiaId(this.usuarioLogado.franquiaId)
                : await estoqueService.estoquesComboVendaCached(this.usuarioLogado.franquiaId);

            const franquiaEstoque = estoqueFiliais.find(p => p["value"] === this.model.estoqueId);
            if (
                franquiaEstoque &&
                franquiaEstoque["franquiaId"] != null &&
                franquiaEstoque["franquiaId"] != this.usuarioLogado.franquiaId
            ) {
                this.showWarningEstoque = true;

                this.estoquesOptions = this.estoquesOptions.filter(
                    p => p["value"] === this.model.estoqueId || p["franquiaId"] === franquiaEstoque["franquiaId"],
                );
            }
            const produtos = await produtoService
                .getByEstoqueId(this.model.estoqueId)
                .withLoading()
                .resolveWithJSON<ProdutoModel[]>();

            this.produtosOptions = produtos.map(getProdutoCombo);
        } else {
            this.loadProdutos();
        }
    }

    private async loadLotesProduto() {
        const produtoLote = await this.produtoLoteService
            .getLotesDisponiveis([this.model.produtoId!], this.model.estoqueId!)
            .withLoading()
            .resolveWithJSON<ProdutoLoteModel[]>();
        this.produtosLoteOptions = produtoLote.map(item =>
            getProdutoLoteCombo(item, this.isFracionamento || this.isEstereis),
        );

        if (!this.model.id && produtoLote.length > 0) {
            this.model.produtoLoteId = produtoLote[0].id;
        }
    }

    private async onProdutoIdChanged(newValue) {
        if (!newValue) return;

        let unidadeMedidaId = 0;
        try {
            const data = await produtoService.getById(newValue).withLoading().resolveWithJSON<ProdutoModel>();
            this.markup = data.markup;
            unidadeMedidaId = data.unidadeMedidaEstoqueId;
            this.model.unidadeMedidaId = unidadeMedidaId;
            if (data.posologiaId) {
                this.model.posologiaId = data.posologiaId;
            }

            this.$emit("onChangeMovimentaEstoque", !data.ignoraControleEstoque);

            if (data.valorVenda) {
                this.model.valorUnitario = this.utilizaValorCusto ? data.valorCusto : data.valorVenda;

                const unidadeMedida = await unidadeMedidaService.get(unidadeMedidaId);
                this.unidadeMedidaSigla = unidadeMedida.sigla;
                this.unidadeMedidaOptions = [{ value: unidadeMedida.id, text: unidadeMedida.descricao }];
            }

            this.loadLotesProduto();

            this.calcularValorTotal();
        } catch {}
    }

    @Watch("model.valorTotal")
    private onValorChanged() {
        this.$emit("atualiza-total-item", this.model.valorTotal);
    }

    @Watch("model.movimentaEstoque")
    private onMovimentaEstoqueChanged() {
        if (!this.model.movimentaEstoque) {
            this.produtoLoteIdSelecionado = this.model.produtoLoteId;
            this.model.produtoLoteId = null;
        } else if (this.produtoLoteIdSelecionado) {
            this.model.produtoLoteId = this.produtoLoteIdSelecionado;
        }
    }

    @Watch("model.prescritorId")
    private async onPrescritorId() {
        if (this.model.prescritorId && this.prescritorModel.id != this.model.prescritorId) {
            this.prescritorModel = await new PrescritorService()
                .get(this.model.prescritorId)
                .resolveWithJSON<PrescritorModel>();

            if (this.prescritorModel.observacao) {
                await this.$showWarning(
                    this.$t("__.Components.parent.manipulacao.edit_vue_html.msgPrescritorObs"),
                    this.prescritorModel.observacao,
                );
            }
        }
    }

    private async onChangePosologia(posologiaId: number) {
        if (posologiaId) {
            this.model.posologiaTexto = null;

            if (this.continuo) {
                const response = await this.$showQuestion(
                    "Contínuo",
                    this.$t("__.ts.desejaRecalcularDataVencimentoContinuo"),
                );

                if (response) {
                    const novaDataContinuo = await this.vendaContinuoService
                        .getDataContinuo(this.model, null)
                        .resolveWithJSON<Date>();

                    if (novaDataContinuo) {
                        this.dataVencimentoContinuo = new Date(novaDataContinuo);
                    }
                }
            }
        }
    }

    @Watch("model.posologiaId")
    private async onPosologiaIdChanged(posologiaId: number) {
        if (!posologiaId || !this.isPosologiaTextoLivre || this.model.posologiaTexto) {
            return;
        }

        const posologia = await posologiaService
            .getFromSearchComboById(posologiaId, this.usuarioLogado.franquiaId)
            .resolveWithJSON<PosologiaModel>();

        if (posologia) {
            this.model.posologiaTexto = posologia.descricao;
        }
    }

    @Watch("model.produtoLoteId")
    private async onChangeProdutoLoteId() {
        if (this.model.produtoLoteId) {
            this.produtoLoteModel = await this.produtoLoteService
                .get(this.model.produtoLoteId)
                .resolveWithJSON<ProdutoLoteModel>();

            try {
                this.quantidadeComprometidaLote = await this.estoqueComprometidoService
                    .getQuantidadeComprometidaLote(this.model.produtoLoteId, this.model.id, this.model.estoqueId)
                    .resolveWithJSON<number>();

                this.produtoLoteModel.quantidadeAtual = this.produtoLoteModel.estoqueProdutoLote.find(
                    p => p.estoqueId == this.model.estoqueId,
                ).estoqueAtual;
            } catch {}
        }
    }

    private calcularValorTotal() {
        if (this.model.quantidade && this.model.valorUnitario) {
            this.model.valorTotal = this.model.quantidade * this.model.valorUnitario;

            if (this.model.desconto) this.model.valorTotal -= this.model.desconto;

            if (this.model.acrescimo) this.model.valorTotal += this.model.acrescimo;

            if (this.markup > 0) {
                this.model.valorTotal = arithmeticHelper.round(
                    (this.model.valorTotal * this.markup) / 100 + this.model.valorTotal,
                    4,
                );
            }
        }
    }

    public async loadModel(item: VendaItemModel) {
        this.editingModel = true;
        this.uplodingModel = true;

        this.continuo = item.continuo;
        this.dataVencimentoContinuo = item.dataVencimentoContinuo;

        let produto = null;

        if (this.usuarioLogado.franquia.matrizId && item.estoqueId) {
            const produtos = await produtoService
                .getByEstoqueId(item.estoqueId)
                .withLoading()
                .resolveWithJSON<ProdutoModel[]>();

            produto = produtos.find(p => p.id == item.produtoId);
        } else {
            produto = await produtoService
                .getById(item.produtoId, 0, true)
                .withLoading()
                .resolveWithJSON<ProdutoModel[]>();
        }

        this.markup = produto.markup * 100;

        const produtoLote = await this.produtoLoteService
            .listByProdutoIdAndEstoqueId(item.produtoId, item.estoqueId, 0.00001, 0, 1, 999999)
            .withLoading()
            .resolveWithJSON<PaginationModel<ProdutoLoteModel>>();
        this.produtosLoteOptions = produtoLote.list.map(lote =>
            getProdutoLoteCombo(lote, this.isFracionamento || this.isEstereis),
        );

        this.model.updateFrom(item);

        this.$focusField("quantidade");
        this.uplodingModel = false;
    }

    private async onAddNewPaciente(closeModal) {
        if (await this.pacienteComponent.save()) {
            closeModal();
        }
    }

    private async onAddNewPosologia(closeModal) {
        if (await this.posologiaComponent.save()) {
            closeModal();
        }
    }

    private async onAddNewPrescritor(closeModal) {
        if (await this.prescritorComponent.save()) {
            closeModal();
        }
    }

    private async openComboNewPaciente() {
        this.showPaciente = true;

        while (!this.$refs.pacienteComponent) await Delay(5);
        this.pacienteComponent = this.$refs.pacienteComponent as PacienteComponent;

        this.pacienteComponent.modelId = 0;
        this.pacienteComponent.load();
    }

    private async openComboNewPosologia() {
        this.posologiaComponent.modelId = 0;
        this.posologiaComponent.load();
    }

    private async openComboNewPrescritor() {
        this.showPrescritor = true;

        while (!this.$refs.prescritorComponent) await Delay(5);
        this.prescritorComponent = this.$refs.prescritorComponent as PrescritorComponent;

        this.prescritorComponent.modelId = 0;
        this.prescritorComponent.load().withLoading();
    }

    private async openComboEditPrescritor(id: number) {
        this.showPrescritor = true;

        while (!this.$refs.prescritorComponent) await Delay(5);
        this.prescritorComponent = this.$refs.prescritorComponent as PrescritorComponent;

        this.prescritorComponent.modelId = id;
        this.prescritorComponent.load().withLoading();
    }

    private async openComboEditPosologia(id: number) {
        this.posologiaComponent.modelId = id;
        this.posologiaComponent.load();
    }

    private async openComboEditPaciente(id: number) {
        this.showPaciente = true;

        while (!this.$refs.pacienteComponent) await Delay(5);
        this.pacienteComponent = this.$refs.pacienteComponent as PacienteComponent;

        this.pacienteComponent.modelId = id;
        this.pacienteComponent.load();
    }

    private async onPacienteSaveOk(modelNovoPaciente: PacienteModel) {
        this.model.pacienteId = modelNovoPaciente.id;
    }

    private async onPosologiaSaveOk(modelNovaPosologia: PosologiaModel) {
        this.model.posologiaId = modelNovaPosologia.id;
    }

    private async onPrescritorSaveOk(modelNovoPrescritor: PrescritorModel) {
        this.model.prescritorId = modelNovoPrescritor.id;
    }

    private tabIndex(valor) {
        if (valor != null && valor > 0) {
            return -1;
        }

        return null;
    }

    public async setPreLoad() {
        if (this.pacienteIdApp != null && this.pacienteIdApp > 0) {
            this.model.pacienteId = this.pacienteIdApp;

            const pacienteComponent = this.$el.querySelector("#pacienteId") as HTMLSelectElement;
            if (pacienteComponent.innerText) {
                this.pacienteDescricao = pacienteComponent.innerText;
            }
        }

        this.loadProdutos();

        this.model.quantidade = 1;
    }

    private usarEstoqueEntreFiliais() {
        return (
            this.usuarioLogado.franquia.matrizId &&
            this.GET_CONFIG_FRANQUIA(Configuracoes.PermiteVendaEmEstoqueDeFiliais)?.verdadeiro
        );
    }

    private async loadEstoques() {
        this.estoquesOptions = this.usarEstoqueEntreFiliais()
            ? await estoqueByFranquiaService.comboCachedByFranquiaId(this.usuarioLogado.franquiaId)
            : await estoqueService.estoquesComboVendaCached(this.usuarioLogado.franquiaId);

        if (this.GET_CONFIG_FRANQUIA(Configuracoes.EstoquePadrao).estoqueId > 0) {
            this.model.estoqueId = this.GET_CONFIG_FRANQUIA(Configuracoes.EstoquePadrao).estoqueId;
        } else if (this.estoquesOptions.length == 1) {
            this.model.estoqueId = this.estoquesOptions[0]["value"];
        }
    }

    private async mounted() {
        this.posologiaComponent = this.$refs.posologiaComponent as PosologiaComponent;

        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        this.loadEstoques();
        this.loadProdutos();

        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
        this.isEstereis = await this.GET_IS_ESTEREIS();
        this.isObrigatorioProdutoLote = this.GET_CONFIG_FRANQUIA(Configuracoes.LoteProdutoAcabado).verdadeiro;
        if (!this.GET_CONFIG_FRANQUIA(Configuracoes.EmiteNotaFiscalConsumidor).verdadeiro) {
            this.tipoNFOptions = this.tipoNFOptions.filter(o => o["value"] !== TipoNotaFiscal.CupomFiscal);
        }

        if (this.isSituacaoPreVenda) {
            this.model.movimentaEstoque = false;
        }
    }
}
